const initialState = {
  userLat: -25.390609,
  userLng: -49.225982,
  lat: -25.390609,
  lng: -49.225982,
  error: '',
  zoom: 12,
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LAT':
      return {
        ...state,
        lat: action.payload,
      };
    case 'SET_LNG':
      return {
        ...state,
        lng: action.payload,
      };
    case 'SET_POS':
      return {
        ...state,
        lat: action.payload.lat,
        lng: action.payload.lng,
      };
    case 'SET_USER_POS':
      return {
        ...state,
        userLat: action.payload.lat,
        userLng: action.payload.lng,
      };
    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.payload,
      };
    default:
      return state;
  }
};

export default mapReducer;
